<template>
  <div>
    <div class="bg-white container mb-28 mx-auto flex flex-col-reverse md:flex-row gap-5">
      <!-- Left Column: Content -->
      <div class="w-full md:w-[35%] flex flex-col justify-center">
        <h2 class="flex md:flex-col text-2xl md:text-3xl font-bold">
          <span class="text-primary-gray-800 mr-2">Discover</span>
          <span class="text-primary-purple-600">MyQampus</span>
        </h2>
        <h4
          class="font-semibold pt-1 md:pt-6 pb-1 md:pb-2.5 text-primary-gray-600 text-base md:text-lg"
        >
          Where Education Meets Automation and Empowerment
        </h4>
        <Paragraph text="WELCOME_TO_MYQAMPUS_DESCRIPTION" child-class="mx-0" />
      </div>
      <div class="w-full md:w-[65%] bg-primary-purple-100 rounded-2xl">
        <div class="aspect-[16/9] w-full overflow-hidden rounded-2xl h-full">
          <iframe
            v-if="isYouTubeVideo"
            class="w-full h-full object-cover rounded-2xl"
            :src="youtubeEmbedLink"
            title="YouTube video"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
          <video
            v-else
            class="w-full h-full object-cover rounded-2xl"
            controls
            :poster="posterImage"
          >
            <source :src="localVideoSrc" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
      </div>
    </div>

    <!-- feature modal -->
    <FeatureDetailCarouselModal
      v-if="showFeatureModal"
      :show-demo-modal="showFeatureModal"
      :content="contentData"
      @closeShowModal="closeFeatureDetailCarouselModal"
    />
    <!-- Card Setion -->
    <CardSetion
      title="HP_WMQ_TITLE"
      description="HP_WMQ_DESC"
      :cards="homePageCards"
      background-color=" bg-primary-purple-50"
      :background="true"
      :explore-btn="true"
    />
    <div
      class="bg-white w-full flex items-center justify-center text-base md:text-xl text-primary-orange font-medium text-center md:pt-15 sm:pt-12.5 pt-8"
    ></div>
  </div>
</template>

<script>
import FeatureDetailCarouselModal from '@src/components/modals/FeatureDetailCarouselModal.vue'
import { CARD_LIST } from '@src/constants/general-constants'
import Paragraph from '@components/home-page/DemoSectionParagarph.vue'
import CardSetion from '@/src/views/home-page/CardSection.vue'

export default {
  components: {
    FeatureDetailCarouselModal,
    Paragraph,
    CardSetion,
  },
  data: function () {
    return {
      isYouTubeVideo: true, 
      youtubeVideoId: 'Dq-ZSMSE0cQ', 
      localVideoSrc: '/videos/SampleVideo_1280x720_1mb.mp4',
      posterImage: '/path/to/preview.jpg',
      contentData: '',
      showFeatureModal: false,
      landingPage: 'landingPage',
      slide: {
        imgSrc: require('@assets/images/home-page/school-banner.png'),
        altText: 'school-banner',
      },

      cards: CARD_LIST,
      sectionFirstDec: [
        'WHY_SHOULD_YOU_CHOOSE_US_D1',
        'WHY_SHOULD_YOU_CHOOSE_US_D2',
        'WHY_SHOULD_YOU_CHOOSE_US_D3',
        'WHY_SHOULD_YOU_CHOOSE_US_D4',
        'WHY_SHOULD_YOU_CHOOSE_US_D5',
        'WHY_SHOULD_YOU_CHOOSE_US_D6',
      ],
      sectionSecondDec: [
        'PROVIDING_DES_1',
        'PROVIDING_DES_2',
        'PROVIDING_DES_3',
        'PROVIDING_DES_4',
        'PROVIDING_DES_5',
        'PROVIDING_DES_6',
        'PROVIDING_DES_7',
      ],

      sectionThirdDec: [
        'PROVIDING_DES_8',
        'PROVIDING_DES_9',
        'PROVIDING_DES_10',
        'PROVIDING_DES_11',
        'PROVIDING_DES_12',
        'PROVIDING_DES_13',
      ],
    }
  },
  computed: {
    homePageCards() {
      return this.cards.filter((card) => card.showCard)
    },
    youtubeEmbedLink() {
      return `https://www.youtube.com/embed/${this.youtubeVideoId}`
    },
  },
}
</script>

<style scoped>
.bg-demo-gradient {
  background: transparent linear-gradient(180deg, #e8f3edfc 0%, #ffffff 100%);
}

.bg-how-it-works-gradient {
  background: #f5faf7 0% 0% no-repeat padding-box;
}

.bg-btn {
  background: transparent linear-gradient(252deg, #ffc268 0%, #ffa31a 100%) 0% 0% no-repeat
    padding-box;
}

.bg-how-it-work-btn-1 {
  background: transparent linear-gradient(213deg, #ffc870 0%, #f7a92b 100%) 0% 0%;
  box-shadow: 1px 1px 12px #ffa7193b;
}

.bg-how-it-work-btn-2 {
  background: transparent linear-gradient(207deg, #c3b6fb 0%, #9983fc 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 1px 1px 12px #8419ff3b;
}

.bg-how-it-work-btn-3 {
  background: transparent linear-gradient(214deg, #8dbfff 0%, #4e8ddd 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 1px 1px 12px #196dff3b;
}

.bg-how-it-work-btn-4 {
  background: transparent linear-gradient(213deg, #75ff90 0%, #61d978 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 1px 1px 12px #19ff843b;
}

.bg-how-it-work-btn-5 {
  background: transparent linear-gradient(213deg, #d8e443 0%, #afb83b 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 1px 1px 12px #9ec7863b;
}

.bg-how-it-work-btn-6 {
  background: transparent linear-gradient(213deg, #ff8982 0%, #f94f46 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 1px 1px 12px #fd98ba3b;
}

.bg-how-it-work-btn-7 {
  background: transparent linear-gradient(213deg, #b4ff82 0%, #8ef946 100%) 0% 0% no-repeat
    padding-box;
  box-shadow: 1px 1px 12px #fd98ba3b;
}

.admin-icon-bg {
  background: #feefd7 0% 0% no-repeat padding-box;
  border-radius: 50%;
}

.teacher-icon-bg {
  background: #e1f7ea 0% 0% no-repeat padding-box;
  border-radius: 50%;
}

.std-icon-bg {
  background: #dbf3ff 0% 0% no-repeat padding-box;
  border-radius: 50%;
}

.guardian-icon-bg {
  background: #ebe6ff 0% 0% no-repeat padding-box;
  border-radius: 50%;
}
</style>
